export const navigationDesk = [
    {nome: 'Ticket', icon: 'pi pi-fw pi-id-card', routerLink: ['ticket']},
    {
        nome: 'Configurações Tickets', icon: 'pi pi-fw pi-cog', routerLink: ['/pages'],
        itens: [
            {nome: 'Minhas Lotações', icon: 'pi pi-fw pi-check-square', routerLink: ['pessoa_lotacao']},
        ]
    }
];
